import helper from '../js/helper';

export default function newsItem (hit, { html }, { locale, keyName, templateType }) {
  let meta = '';
  let body = '';
  let sni = '';

  let thumbnailImage = helper.translate(locale, hit.thumbnail, hit.thumbnailEn);
  if (thumbnailImage === '') {
    thumbnailImage = window.defaultThumbnail.horizontal;
  }

  if (keyName === 'news') {
    if (hit.newsSource) {
      meta = html`
        <i class="fas fa-clock mr-1"></i> ${ helper.translate(locale, hit.postDateId, hit.postDateEn) }
        <span class="mx-1">/</span>
        <i class="fas fa-link mr-1"></i> ${hit.newsSource}
        <span class="mx-1">/</span>
      `;

    } else if (hit.reporterEn || hit.reporter) {
      meta = html`
        <i class="fas fa-clock mr-1"></i> ${ helper.translate(locale, hit.postDateId, hit.postDateEn) }
        <span class="mx-1">/</span>
        <i class="fas fa-user mr-1"></i> ${ helper.translate(locale, hit.reporter, hit.reporterEn) }
        <span class="mx-1">/</span>
      `;

    } else {
      meta = html`
        <i class="fas fa-clock mr-1"></i> ${ helper.translate(locale, hit.postDateId, hit.postDateEn) }
        <span class="mx-1">/</span>
        <i class="fas fa-user mr-1"></i> ${ helper.translate(locale, hit.author, hit.authorEn) }
        <span class="mx-1">/</span>
      `;
    }
  } else if (keyName === 'page') {
    body = html`
    <p class="m-b-0 font-14">
      ${ helper.translate(locale, hit.contentHtml, hit.contentHtmlEn).slice(0, 99) }...
    </p>
  `;
  } else if (keyName === 'product') {
    sni = html`
    <p class="m-b-0 font-14">
      SNI : ${hit.sni}
    </p>
  `;
  }

  if (templateType === 'grid-image') {
    return html`
    <a href="${ hit.url }">
      <div class="card card__news lift-up hover:shadow shadow-sm">
        <div class="card__content">
          <h5 class="card__title">
            ${ helper.translate(locale, hit.title, hit.titleEn) }
          </h5>
        </div>
        <div class="card__thumb">
          <img
            src="${ thumbnailImage }"
            class="img-responsive" alt="${ helper.translate(locale, hit.title, hit.titleEn) }" />
        </div>
      </div>
    </a>
  `;
  }

  return html`
  <div class="news-item row blog-row hover:text-primary mb-4">
    <div class="col-md-3 col-4">
      <div class="overflow-hidden rounded">
        <a href="/${ hit.url }">
          <img
            src="${ thumbnailImage }"
            class="img-responsive rounded transition-fast"
            alt="${ helper.translate(locale, hit.title, hit.titleEn) }"
          />
        </a>
      </div>
    </div>
  
    <div class="col-md-9 col-8">
      <!-- product category label -->
      <div class="label-up">
        <label class="label text-white" style="background: ${ hit.categoryColor }">
          <small class="text-uppercase">
            ${ helper.translate(locale, hit.category, hit.categoryEn) }
          </small>
        </label>
      </div>
      <!-- end of product category label -->
  
      <a class="h6 news-title" href="/${ hit.url }">
        ${ helper.translate(locale, hit.title, hit.titleEn) }
      </a>
  
      ${ sni }
  
      ${ body }
      
      <!-- news meta -->
      <div class="news-meta">
        ${ meta }
      
        <i class="fas fa-eye mr-1"></i>
      
        <span class="${ keyName }-view-${ hit.elementId }">${ hit.viewCount.toLocaleString() }</span>x ${ helper.translate(locale, 'dilihat', 'viewed') }
      </div>
      <!-- end of news meta -->

    </div>
  </div>
  
  <hr/>
  `;
}